import get from 'lodash.get';
import { getAllergies } from '@/services/allergy';

// eslint-disable-next-line no-unused-vars
const initializeAllergies = async (store) => {
  const getAllergiesResponse = await getAllergies();
  return get(getAllergiesResponse, 'data.getAllergies');
};

export default {
  initializeAllergies,
};



// WEBPACK FOOTER //
// ./store/modules/allergies/actions.js